import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/styles.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Features} from "./pages/Features";
import {Compare} from "./pages/Compare";
import {About} from "./pages/About";
import {Analyse} from "./pages/Analyse";
import {Landing} from "./pages/Landing";
import {LanguageProvider} from "./translations/LanguageContext";
import {ErrorBoundary} from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <LanguageProvider>
          <ErrorBoundary>
              <BrowserRouter>
                  <Routes>
                      <Route path="/" element={<Landing />} />
                      <Route path="/analyse" element={<Analyse />}/>
                      <Route path="/compare" element={<Compare />}/>
                      <Route path="/features" element={<Features />}/>
                      <Route path="/about" element={<About />}/>
                  </Routes>
              </BrowserRouter>
          </ErrorBoundary>
      </LanguageProvider>
  </React.StrictMode>
);


reportWebVitals();
